import React, { lazy, Suspense } from "react";

const DynamicComponent = (props) => {
  const component = lazy(() => import(`./${props.component}`));
  return (
    <Suspense fallback={<></>}>
      {React.createElement(component, props)}
    </Suspense>
  );
};

export default DynamicComponent;
